import { Pipe, PipeTransform } from '@angular/core';
import moment from "moment";
import {TranslateService} from "@ngx-translate/core";

@Pipe({
    name: 'frame',
    standalone: false
})
export class FramePipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  transform(value:{start: Date|string, end?: Date|string}, ...args: unknown[]): string {
    if(value && value.start){
      const start = moment(value.start);
      const s = start.format('MMMM YYYY');

      if(value.end){
        const end = moment(value.end);
        const e = end.format('MMMM YYYY');

        if(s === e){
          return s;
        }
        return s + ' - ' + e;
      }
      return s + ' - ' + this.translate.instant('present');
    }
    return null;
  }

}
